(function () {

const $edb5fea78e906b16$var$setSlideInteractive = (slide, isActive)=>{
    slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    if (isActive) slide.removeAttribute('inert');
    else slide.setAttribute('inert', '');
    slide.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((element)=>{
        if (isActive) {
            if (element.dataset.workRelatedTabindex !== undefined) {
                const originalTabindex = element.dataset.workRelatedTabindex;
                if (originalTabindex === '') element.removeAttribute('tabindex');
                else element.setAttribute('tabindex', originalTabindex);
                delete element.dataset.workRelatedTabindex;
            }
            return;
        }
        var _element_getAttribute;
        if (element.dataset.workRelatedTabindex === undefined) element.dataset.workRelatedTabindex = (_element_getAttribute = element.getAttribute('tabindex')) !== null && _element_getAttribute !== void 0 ? _element_getAttribute : '';
        element.setAttribute('tabindex', '-1');
    });
};
const $edb5fea78e906b16$var$updateSlideAccessibility = (swiper, status, announce = true)=>{
    swiper.slides.forEach((slide, index)=>{
        $edb5fea78e906b16$var$setSlideInteractive(slide, index === swiper.activeIndex);
    });
    if (status && announce) status.textContent = `Project ${swiper.realIndex + 1} of ${swiper.slides.length}`;
};
const $edb5fea78e906b16$var$initWorkSingleRelatedProjects = (section)=>{
    if (section.dataset.workSingleRelatedProjectsInitialized === 'true') return;
    const slider = section.querySelector('[data-work-related-slider]');
    const slides = Array.from(section.querySelectorAll('[data-work-related-slide]'));
    const prev = section.querySelector('[data-work-related-prev]');
    const next = section.querySelector('[data-work-related-next]');
    const status = section.querySelector('[data-work-related-status]');
    const { Swiper: Swiper, SwiperModules: SwiperModules } = window.rebredgVendors || {};
    const { A11y: A11y, EffectFade: EffectFade, Keyboard: Keyboard, Navigation: Navigation } = SwiperModules || {};
    if (!slider || slides.length < 2 || !prev || !next || !Swiper || !A11y || !EffectFade || !Keyboard || !Navigation) return;
    section.dataset.workSingleRelatedProjectsInitialized = 'true';
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const defaultSpeed = 650;
    const swiper = new Swiper(slider, {
        modules: [
            Navigation,
            A11y,
            Keyboard,
            EffectFade
        ],
        slidesPerView: 1,
        spaceBetween: 0,
        speed: reducedMotion.matches ? 0 : defaultSpeed,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        simulateTouch: true,
        allowTouchMove: true,
        grabCursor: true,
        threshold: 8,
        watchSlidesProgress: true,
        keyboard: {
            enabled: true,
            onlyInViewport: true,
            pageUpDown: false
        },
        navigation: {
            prevEl: prev,
            nextEl: next,
            disabledClass: 'is-disabled',
            lockClass: 'is-locked'
        },
        a11y: {
            enabled: true,
            prevSlideMessage: 'Previous related project',
            nextSlideMessage: 'Next related project',
            firstSlideMessage: 'This is the first related project',
            lastSlideMessage: 'This is the last related project',
            slideLabelMessage: '{{index}} of {{slidesLength}}'
        },
        on: {
            init (instance) {
                $edb5fea78e906b16$var$updateSlideAccessibility(instance, status, false);
            },
            slideChange (instance) {
                $edb5fea78e906b16$var$updateSlideAccessibility(instance, status);
            }
        }
    });
    const handleReducedMotionChange = (event)=>{
        swiper.params.speed = event.matches ? 0 : defaultSpeed;
    };
    if (typeof reducedMotion.addEventListener === 'function') reducedMotion.addEventListener('change', handleReducedMotionChange);
    else if (typeof reducedMotion.addListener === 'function') reducedMotion.addListener(handleReducedMotionChange);
};
function $edb5fea78e906b16$export$c27fdb48087dd68(root = document) {
    var _context_matches;
    const selector = '[data-component="work-single-related-projects"]';
    const context = root || document;
    const sections = [];
    if (context.nodeType === 1 && ((_context_matches = context.matches) === null || _context_matches === void 0 ? void 0 : _context_matches.call(context, selector))) sections.push(context);
    if (context.querySelectorAll) sections.push(...context.querySelectorAll(selector));
    sections.forEach($edb5fea78e906b16$var$initWorkSingleRelatedProjects);
}


const $c80deb3e9414858d$var$runBlock = ()=>(0, $edb5fea78e906b16$export$c27fdb48087dd68)(document);
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', $c80deb3e9414858d$var$runBlock, {
    once: true
});
else $c80deb3e9414858d$var$runBlock();

})();
//# sourceMappingURL=work-single-related-projects.js.map
